module.exports = __webpack_public_path__ + "img/arrow-right-planos.39fb2e6f.svg";